/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Link_Broken_TitleInputs */



/**
* | output |
* | --- |
* | "The meeting link does not work" |
*
* @param {Meeting_Notetaker_Issue_Link_Broken_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_link_broken_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Link_Broken_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Link_Broken_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De vergaderlink werkt niet")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le lien de la réunion ne fonctionne pas")
	return /** @type {LocalizedString} */ ("The meeting link does not work")
});